export default __webpack_public_path__ + "static/media/mail.c51674ec.svg";